import { render, staticRenderFns } from "./KorbanForm.vue?vue&type=template&id=5a73311a"
import script from "./KorbanForm.vue?vue&type=script&lang=js"
export * from "./KorbanForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports